import PageComponent from '../base/PageComponent';
import iPhoneSafari from '../utils/iPhoneSafari';

export default class Navigation extends PageComponent {

    init() {
        this.mobileNav();
    }

    mobileNav() {
        this.addEvent('.mobile-menu-button', 'click', e => this.onMenuClick(e));
        this.addEvent('.mobile-nav .nav-item > a', 'click', e => this.onDropdownClick(e));
        this.safariNavFix();
    }

    onMenuClick(e) {
        let nav = $('.mobile-nav');

        $('.mobile-nav .nav-dropdown').slideUp();
        $('.mobile-nav .nav-item').removeClass('open');

        if (!this.element.hasClass('no-scroll')) {
            this.element.addClass('no-scroll');
        }
        else {
            this.element.removeClass('no-scroll');
        }

        if ($(e.target).hasClass('glyphicon-menu-hamburger')) {
            $(e.target).removeClass('glyphicon-menu-hamburger');
            $(e.target).addClass('glyphicon-remove ');
        }
        else {
            $(e.target).addClass('glyphicon-menu-hamburger');
            $(e.target).removeClass('glyphicon-remove ');
        }

        if (nav.is(':visible')) {
            nav.fadeOut(200);
        }
        else {
            nav.fadeIn(200);
        }
    }

    onDropdownClick(e) {
        let container = $(e.target).closest('li');

        //if it has a submenu
        if (container.find('ul').length) {
            //clicked for first second time - go to link
            if (container.hasClass('open')) {
                return true;
            }

            container.find('ul').slideUp();
            container.find('ul').not(container).removeClass('open');

            if (!container.hasClass('open')) {
                e.preventDefault();

                $('.mobile-nav .nav-dropdown').slideUp();
                $('.mobile-nav .nav-item').removeClass('open');

                container.find('ul').slideDown();
                container.addClass('open');
            }
        }
        return true;
    }

    safariNavFix() {
        if (iPhoneSafari()) {
            $('.nav-item.dropdown').css({
                'display': 'table',
                'width': '100%',
            });
            $('.nav-item.dropdown > li').css('display', 'table-row');
        }
    }

}


// WEBPACK FOOTER //
// ./javascript/components/Navigation.js